import React, {useCallback} from 'react'
import {getAllFilterKeys} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const allFilterKeys = getAllFilterKeys()

export const MobileFiltersButton = () => {
  const {getAppliedFiltersCount} = useFiltersForm(allFilterKeys, 'allFilters')
  const numberOfSelectedFilters = getAppliedFiltersCount()
  const isActive = numberOfSelectedFilters > 0

  const showOverlay = useShowOverlay()

  const handleShowFilters = useCallback(
    (event?: React.SyntheticEvent) => {
      event?.preventDefault()

      showOverlay({type: OverlayType.Filters})
    },
    [showOverlay]
  )

  return (
    <Pill
      fullWidth={false}
      isSelected={isActive}
      onClick={handleShowFilters}
      count={numberOfSelectedFilters}
    >
      <Icon name="SettingsSliders" />
    </Pill>
  )
}
